import { render, staticRenderFns } from "./CommunityPostsCard1.vue?vue&type=template&id=1bad71aa&"
import script from "./CommunityPostsCard1.vue?vue&type=script&lang=js&"
export * from "./CommunityPostsCard1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports